export class LazyLoadController {

	/**
	 * @type {import('lit').ReactiveControllerHost}
	 */
	host;

	/**
	 * @type {IntersectionObserver}
	 */
	observer;

	/**
	 * @type {IntersectionObserverInit}
	 */
	observerOptions;

	/**
	 * @type {boolean}
	 */
	loaded = false;

	/**
	 * @param {any} host An instance of LitElement
	 * @param {IntersectionObserverInit} observerOptions Options to be passed to the IntersectionObserver
	 */
	constructor (host, lazyCallback = () => void 0, observerOptions = {}) {
		(this.host = host).addController(this);

		// Define options
		this.lazyCallback = lazyCallback.bind(host);
		this.observerOptions = observerOptions;
	}

	hostConnected () {
		this.observer = new IntersectionObserver(this.handleObserve.bind(this), this.observerOptions);
		this.observer.observe(this.host);
	}

	hostDisconnected () {
		this.observer.disconnect();
	}

	/**
	 * Handle the observer callback
	 * @param {IntersectionObserverEntry[]} entries
	 */
	handleObserve ([element]) {
		if (element.isIntersecting) {
			this.loaded = true;
			this.lazyCallback();
			this.observer.disconnect();
		}
	}
};
